import { onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6f874088"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-content bgHeader"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "user-name"
}, "任务", -1));
const _hoisted_3 = {
  class: "productIMG"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "txt"
}, "暂无任务", -1));
const _hoisted_5 = {
  class: "virtual-table-wrapper"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "header-cell",
  style: {
    "width": "200px"
  }
}, "任务名称"), /*#__PURE__*/_createElementVNode("div", {
  class: "header-cell",
  style: {
    "width": "200px"
  }
}, "任务状态"), /*#__PURE__*/_createElementVNode("div", {
  class: "header-cell",
  style: {
    "width": "70px"
  }
}, "操作")], -1));
const _hoisted_7 = {
  class: "table-cell",
  style: {
    "width": "200px"
  }
};
const _hoisted_8 = {
  class: "task-name"
};
const _hoisted_9 = {
  class: "table-cell",
  style: {
    "width": "200px"
  }
};
const _hoisted_10 = {
  key: 0,
  class: "task-status"
};
const _hoisted_11 = {
  class: "table-cell",
  style: {
    "width": "70px"
  }
};
import SvgIcon from '@/components/SvgIcon.vue';
import { postBillList, postBillDel } from '@/api/thirdParty';
import { OK } from '@/common';
import { message } from 'ant-design-vue';
import VirtualScroll from '@/components/VirtualScrolling.vue';
import { ref, nextTick } from 'vue';
import * as Sentry from '@sentry/vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'testList',
  setup(__props) {
    const options = [{
      label: '未完成',
      key: '1'
    }, {
      label: '已完成',
      key: '2'
    }];
    // const delIndex = ref<number>(-1)
    const activeKey = ref('1');
    const finishList = ref([]);
    const noFinishList = ref([]);
    const open = ref(false);
    const dataSource = ref([]);
    const loading = ref(false);
    const isInitialized = ref(false);
    // 缓存数据
    const cachedData = ref({
      '1': [],
      '2': []
    });
    // 定义每行的高度
    const ITEM_HEIGHT = 40;
    const VISIBLE_COUNT = 10;
    const openChange = async value => {
      if (value) {
        loading.value = true;
        try {
          await getTestList();
          activeKey.value = '1';
          await nextTick();
          handleTabChange('1');
          if (!isInitialized.value) {
            isInitialized.value = true;
          }
        } catch (error) {
          console.error('Failed to load data:', error);
          message.error('加载数据失败，请重试');
        } finally {
          loading.value = false;
        }
      }
      open.value = value;
    };
    const delTestItem = async id => {
      loading.value = true;
      try {
        const {
          code,
          msg
        } = await postBillDel({
          id
        });
        if (code === OK) {
          message.success(msg);
          await getTestList();
          handleTabChange(activeKey.value);
        } else {
          message.error(msg || '删除失败');
        }
      } catch (error) {
        console.error('删除任务失败:', error);
        message.error('删除失败，请重试');
      } finally {
        loading.value = false;
      }
    };
    const getTestList = async () => {
      try {
        const param = {
          pageNum: 1,
          pageSize: 1000,
          taskStatusList: [0, 10, 20, 30],
          taskTypeList: [0, 10]
        };
        const res = await postBillList(param);
        if ((res === null || res === void 0 ? void 0 : res.code) === OK) {
          var _res$data, _res$data2;
          // 预处理数据并缓存
          cachedData.value['2'] = (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.list) === null || _res$data === void 0 ? void 0 : _res$data.filter(item => item.taskStatus === 20)) || [];
          cachedData.value['1'] = (res === null || res === void 0 || (_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.list) === null || _res$data2 === void 0 ? void 0 : _res$data2.filter(item => [0, 10, 30].includes(item.taskStatus))) || [];
          // 使用缓存数据
          finishList.value = cachedData.value['2'];
          noFinishList.value = cachedData.value['1'];
          return true;
        }
      } catch (error) {
        console.error('获取任务列表失败:', error);
        if (process.env.VUE_APP_IS_SENTRY === 'true') {
          Sentry.captureException(error);
        }
      }
    };
    const handleTabChange = async key => {
      activeKey.value = key;
      // 从缓存中获取数据
      await nextTick();
      dataSource.value = cachedData.value[key] || [];
    };
    // const showIcon = (index: number) => {
    //   delIndex.value = index
    // }
    // const hideIcon = () => {
    //   delIndex.value = -1
    // }
    onMounted(async () => {
      await getTestList();
    });
    return (_ctx, _cache) => {
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      return _openBlock(), _createBlock(_component_a_dropdown, {
        placement: "bottomRight",
        open: open.value,
        "onUpdate:open": _cache[1] || (_cache[1] = $event => open.value = $event),
        onOpenChange: openChange
      }, {
        overlay: _withCtx(() => [!(noFinishList.value.length || finishList.value.length) ? (_openBlock(), _createBlock(_component_a_menu, {
          key: 0
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(SvgIcon, {
            "icon-class": "wushuju"
          }), _hoisted_4])]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_a_menu, {
          key: 1,
          style: {
            "width": "600px",
            "padding": "18px",
            "box-sizing": "border-box"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_a_tabs, {
            activeKey: activeKey.value,
            "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => activeKey.value = $event),
            type: "card",
            class: "test-list-tabs",
            onChange: handleTabChange
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, item => {
              return _createVNode(_component_a_tab_pane, {
                key: item.key,
                tab: item.label
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_a_spin, {
                  spinning: loading.value
                }, {
                  default: _withCtx(() => [isInitialized.value && !loading.value ? (_openBlock(), _createBlock(VirtualScroll, {
                    key: 0,
                    items: dataSource.value,
                    "item-height": ITEM_HEIGHT,
                    "visible-count": VISIBLE_COUNT,
                    "style-obj": {
                      height: '400px'
                    }
                  }, {
                    default: _withCtx(({
                      items
                    }) => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, record => {
                      return _openBlock(), _createElementBlock("div", {
                        key: record.id,
                        class: "table-row",
                        style: _normalizeStyle({
                          height: ITEM_HEIGHT + 'px'
                        })
                      }, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_a_tooltip, {
                        title: record.taskName
                      }, {
                        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString(record.taskName), 1)]),
                        _: 2
                      }, 1032, ["title"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_a_tooltip, {
                        title: record.taskStatusMsg
                      }, {
                        default: _withCtx(() => [record.taskStatus == 30 ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(record.taskStatusMsg), 1)) : _createCommentVNode("", true)]),
                        _: 2
                      }, 1032, ["title"]), record.taskStatus == 20 ? (_openBlock(), _createBlock(SvgIcon, {
                        key: 0,
                        "icon-class": "success_2",
                        class: "delete"
                      })) : _createCommentVNode("", true), record.taskStatus == 10 ? (_openBlock(), _createBlock(SvgIcon, {
                        key: 1,
                        "icon-class": "waiting",
                        class: "waiting"
                      })) : _createCommentVNode("", true), record.taskStatus == 0 ? (_openBlock(), _createBlock(SvgIcon, {
                        key: 2,
                        "icon-class": "shalou",
                        class: "shalou"
                      })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, [record.taskStatus == 30 || record.taskStatus == 20 ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        onClick: $event => delTestItem(record.id),
                        class: "delete-btn",
                        type: "link"
                      }, {
                        default: _withCtx(() => [_createTextVNode(" 删除 ")]),
                        _: 2
                      }, 1032, ["onClick"])) : _createCommentVNode("", true)])], 4);
                    }), 128))]),
                    _: 1
                  }, 8, ["items"])) : _createCommentVNode("", true)]),
                  _: 1
                }, 8, ["spinning"])])]),
                _: 2
              }, 1032, ["tab"]);
            }), 64))]),
            _: 1
          }, 8, ["activeKey"])]),
          _: 1
        }))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(SvgIcon, {
          "icon-class": "test",
          "class-name": "user-icon"
        }), _hoisted_2])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});